import { z } from 'zod';
import { baseString } from './core/primitives';
import { str, emptyToUndefined } from './core/helpers';

const WF_NAME_MAX = 255;
const WF_DESCRIPTION_MAX = 2000;

export const createWorkflowSchema = (t) =>
  z.object({
    name: z.preprocess(
      str,
      baseString
        .min(1, t('validation.workflow.name.required'))
        .max(
          WF_NAME_MAX,
          t('validation.workflow.name.maxLength', { max: WF_NAME_MAX })
        )
    ),
    description: baseString
      .max(
        WF_DESCRIPTION_MAX,
        t('validation.workflow.description.maxLength', {
          max: WF_DESCRIPTION_MAX,
        })
      )
      .optional(),
  });

export const updateWorkflowSchema = (t) =>
  z.object({
    name: z
      .preprocess(
        str,
        baseString
          .min(1, t('validation.workflow.name.required'))
          .max(
            WF_NAME_MAX,
            t('validation.workflow.name.maxLength', { max: WF_NAME_MAX })
          )
      )
      .optional(),
    description: emptyToUndefined(
      baseString
        .max(
          WF_DESCRIPTION_MAX,
          t('validation.workflow.description.maxLength', {
            max: WF_DESCRIPTION_MAX,
          })
        )
        .optional()
    ),
  });

export { WF_NAME_MAX, WF_DESCRIPTION_MAX };
